/*
 * $Id:: index.js 2021/03/02 04:18 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { userCan } from '../../../common/utils/service';
import PageTitle from '../../../components/PageTitle';
import { t } from '../../../providers';
import { me as meSlice } from '../../AuthenticatedPage/authenticationSlice';
import ChildAccounts from '../components/ChildAccounts';
import LoginDetails from '../components/LoginDetails';
import Preferences from '../components/Preferences';
import ProfileDetails from '../components/ProfileDetails';

const useStyles = makeStyles(() => ({
    container: {
        height: '100%',
        minWidth: 'calc(100% - 296px)',

        '@media (max-width:960px)': {
            minWidth: '100%',
        },
    },
    childTab: {},
    tabs: {
        '& .MuiTabs-scroller::-webkit-scrollbar-thumb': {
            backgroundColor: 'unset',
        },
        marginBottom: '20px',
    },
    tabContainer: {
        width: '100%',
    },
    profileTabContainer: {
        '@media (min-width:961px)': {
            width: '653px',
        },
    },
    childAccountsTabContainer: {
        marginRight: '20px',
        width: 'auto',
        '@media (max-width:960px)': {
            width: 'fit-content',
        },
    },
}));

const LOGIN_DETAILS = 'login-details';
const PROFILE_DETAILS = 'profile-details';
const PREFERENCES = 'preferences';
const CHILD_ACCOUNTS = 'child-accounts';

const AccountDetailsPage = () => {
    const { tab } = useParams();
    const history = useHistory();
    const classes = useStyles();
    const { authorities } = useSelector(meSlice);

    const tabs = [PREFERENCES];

    const canManageChilds = userCan(authorities, 'ROLE_CHILD_ACCOUNT_ADMIN');
    if (canManageChilds) tabs.push(CHILD_ACCOUNTS);

    useEffect(() => {
        if (!tab || tabs.indexOf(tab) === -1) history.push(`/my-account/${PREFERENCES}`);
    }, [history, tab, tabs]);

    return (
        <div className={[classes.container, tab === CHILD_ACCOUNTS ? classes.childTab : ''].join(' ')}>
            <PageTitle title={t('my.account')} details={t('details.about.profile.preferences')} />
            <div
                className={[
                    classes.tabContainer,
                    tab === PREFERENCES ? classes.childAccountsTabContainer: '',
                    tab !== CHILD_ACCOUNTS || tab !== PREFERENCES ? classes.profileTabContainer : '',
                    tab === CHILD_ACCOUNTS ? classes.childAccountsTabContainer : '',
                ].join(' ')}>
                {tab === LOGIN_DETAILS && <LoginDetails />}
                {tab === PROFILE_DETAILS && <ProfileDetails />}
                {tab === PREFERENCES && <Preferences />}
                {tab === CHILD_ACCOUNTS && <ChildAccounts />}
            </div>
        </div>
    );
};

export default AccountDetailsPage;
